/*
 * Copyright (c) 2021 SARL SIGMA POLYNESIA
 */

import { consoleOutput, INFO, Logger } from '@jalik/logger'

/**
 * Main client logger.
 */
const logger = new Logger({
  active: true,
  level: INFO,
  name: 'main',
  outputs: [
    consoleOutput({
      formatter: (event) => {
        const context = event.context
          ? ` ${JSON.stringify(event.context)}`
          : ''
        return `${event.level.toUpperCase()} : ${event.message}${context}`
      }
    })
  ]
})

export default logger
